<template>
    <div class="mt-5 pt-5">
        <BContainer ref="cyprusfiles_confidentialclients" class="cyprusfiles_confidentialclients">

            <BRow class="no-gutters justify-content-center mt-5 pt-5">
              <BCol lg="5" md="9" sm="12">
                <h5 class="text-primary fs-18px text-center">{{ $t("appContent.kicker") }}</h5>       
                <h1 class="app_title text-center">{{ $t("appContent.title") }}</h1>       
              </BCol>
            </BRow>
            <BRow class="pt-3 pb-3 no-gutters justify-content-center">
                <BCol lg="5" md="9" sm="12">
                    <div class="text-center app_description mb-5">
                        <span v-html="$t('appContent.excerpt')"></span>
                    </div>
                </BCol>
            </BRow>
            <BRow class="no-gutters justify-content-center">
              <BCol md="6" sm="6" class="social-bar">
                <SocialShare :layout="`home`" :title="$t('appContent.social_all')" :share-link="$t('main_url')"/>
              </BCol>
            </BRow>
            <BRow class="no-gutters justify-content-center">
              <BCol lg="6" md="7" sm="12">
                <div class="text-center mb-5">
                    <logoProgress />
                </div>
                
              </BCol>
            </BRow>

        </BContainer>

        <div ref="power_players_wrapper" class="power_players_wrapper position-relative overflow-hidden">
            <BRow class="justify-content-center">
                <BCol cols="12" sm="12" md="12" 
                v-for="(player, ix) in players"
                :ref="`case_index_${player.index}`"
                :data-index="player.index"
                :id="kebabCase(player.name)"
                :key="kebabCase(player.name)" 
                class="item-character-list"
                >
                    <BRow
                    class="avatar-item no-gutters d-flex justify-content-center align-items-center p-5" :class="{'flex-row-reverse': ix%2==0}"
                    >
                        <BCol md="7" sm="12" cols="12">
                            <div class="avatar-character-container">
                                <div class="bg-avatar">
                                    <img width="100%" src="@/assets/bg-nicosia.png" />
                                </div>
                                <div v-b-modal="`modal_${player.index}`" class="avatar-player">
                                    <img :src="getPicture(player.url, true)" :alt="`${player.name}`"  />
                                </div>
                            </div>
                        </BCol>

                        <BCol md="5" sm="12" cols="12">
                            <div 
                            class="item-player-title">
                                <div class="line-vertical-file"></div>
                                <h3 v-b-modal="`modal_${player.index}`" class="text-left fs-52px name-player">
                                    {{ player.name }}
                                </h3>
                                <div class="line-vertical-file"></div>
                                <h4 class="pt-2 pb-2 text-primary fs-30px name-player">{{ player.title }}</h4>
                                <div class="text-intro">
                                    <label class="badge-secondary">{{ $t('appContent.entities_leak')}}: </label>
                                    <div class="d-flex">
                                        <div class="p-2 text-center">
                                            <h5 class="fs-44px name-player">{{ player.companies_nro }}</h5>
                                            <label class="">Companies</label>
                                        </div>
                                        <div class="p-2 text-center" v-if="player.trusts_nro > 0">
                                            <h5 class="fs-44px name-player">{{ player.trusts_nro }}</h5>                                       
                                            <label class="">Trusts</label>
                                        </div>
                                    </div>
                                </div>
                               
                                <div class="text-left p-3">
                                    <span class="mt-3 d-inline-block btn btn-dark font-weight-900" v-b-modal="`modal_${player.index}`"> {{ $t('modal.btn_read') }}</span>
                                </div>
                            </div>                           
                           
                        </BCol>

                        <Modal :player="player"/>
                    </BRow>
                </BCol>

            </BRow>

        </div>

        <div @click="next" class="btn-next noselect arrow-down-float d-md-none d-block">
            <img :class="reverse ? 'arrowBack' : 'arrow'" :src="require('@/assets/img/arrow-circle.svg')">
        </div>

       

        <IframModal />
    </div>
</template>

<script>
    import utils from '@/mixins/utils'
    import {kebabCase} from 'lodash'
    import Modal from '@/components/Modal'
    import logoProgress from '@/components/logoProgress'
    import IframModal from '@/components/IframModal'
    import SocialShare from '@/components/SocialShare'

    // import store from "../store";
    export default {
        name: 'Home',
        data() {
            return {
                wheeling: false,
                scrollTimeout: null,
                index: 0,
                reverse: false,
                viewIndex: 0,
                hasHeader: false,
                viewLimit: 0,
                isAnimating: false,
                isMobile:false,
                cid: null
            }
        },
        mixins: [utils],
        components: {
            Modal,
            IframModal,
            SocialShare,
            logoProgress
        },
        props: {
            content: {
                type: Object,
                default: null,
            },
        },
        computed: {
            players() {
                return this.$store.state.players.all
            },
            slidesLength() {
                return this.$el.querySelector('.carousel').childElementCount
            },
            slideHeight() {
                return this.$el.querySelector('#CarouselSlide').offsetHeight
            },
            slidesHeight() {
                return false //this.$el.querySelector('.carousel').offsetHeight
            }
        },
        watch: {
            index: function (val) {
                this.reverse = (val == this.slidesLength - 1)
            },
        },

        methods: {
            kebabCase,
            next() {
                window.scrollTo({top: (window.scrollY + 100), left: 0});
            }
        },
        mounted() {
            this.hasHeader = document.querySelector("#main-header") !== null;
            this.viewIndex = this.hasHeader ? 0 : 1;
            this.viewLimit = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
            
            if(this.$route.query && this.$route.query.broker && document.querySelector(`#${this.$route.query.broker}`)) {
                let pos = document.querySelector(`#${this.$route.query.broker}`)
                
                setTimeout(() => {
                    pos.scrollIntoView({behavior: "smooth", block: "center"})
                }, 100)
            }
            

        }
    }

</script>


<style lang="scss">
    #app{
        position: relative;
        width: 100%;
        min-height: 100vh;
        scroll-behavior: smooth;
    }

    @media (min-width: 1465px) {
        .container, .container-sm, .container-md, .container-lg, .container-xl {
            max-width: 1400px;
        }
    }

    .noselect {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .arrowBack {
        transform: rotate(180deg);
    }

    body.disable-scroll {
        overflow: hidden;

    }

    .social-bar .share-module {
        justify-content: center;
    }

    .arrow-down-float {
        position: absolute;
        z-index: 9999;
        bottom: 75px;
        right: 5%;
        cursor: pointer;
    }

    .btn-read-more{
        background-color: transparent;
        color: var(--app-color-red);
        padding: .3rem 1.5rem;
        transition: opacity 300ms;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: fit-content;
        margin: 0 auto;
        font-size: 13px;
        &:hover,&:focus{
            opacity: .9;
        }
    }
    .btn-player{
        background-color: var(--app-color-alt);
        border-color: var(--app-color-alt);
        color: #000;
        padding: .1rem .5rem;
        transition: opacity 300ms;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: fit-content;
        border-radius: 0;
        &:hover,&:focus{
            opacity: .9;
            color: #fff;
        }
    }

    .card-image {
        cursor: url(~@/assets/img/plus.svg), auto;;
        &:focus {
            outline: none;
        }
        .__case-pic {
            width: 100%;
            height: 40vh;
            object-fit: cover;
            object-position: center;
        }
        @media (max-width: 720px) {
            .__case-pic {
                height: 27vh;
            }
        }
    }

    .item-player-title {
        position: relative;
        width: 100%;
        left: calc(-15% - 1px);
        min-height: 110px;
        background: rgba(255, 255, 255, 0.83);

        @media(max-width: 720px) {
            left: 0;
            width: calc(95% - 2px);
            margin: 0 auto;
        }
    }

    .flex-row-reverse .item-player-title {
        position: relative;
        width: calc(125% - 2px);
        left: 0 !important;

        @media(max-width: 720px) {
            width: calc(95% - 2px);
            margin: 0 auto;
        }
    }


    @keyframes floatBottom {
        from {
            transform: translateY(3rem);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }

    @keyframes floatTop {
        from {
            transform: translateY(0rem);
            opacity: 1;
        }
        to {
            transform: translateY(3rem);
            opacity: 0;
        }
    }

    .covid-icon {
        top: 0;
        left: 0;
        img {
            width: 10rem;
            height: auto;
        }
    }

    .plus-icon {
        position: absolute;
        top: 10%;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        img {
            width: 3rem;
            height: auto;
        }

    }

    .power_players_wrapper {
        max-width: 920px;
        margin: 0 auto;
        scroll-behavior: smooth;
        min-height: 100vh;
        padding-top: 320px;

        @media(max-width: 720px) {
            max-width: 385px;
        }

        .name-player {
            font-family: "headline-gothic-atf-rough-n1", sans-serif;
            font-weight: 400;
            font-style: normal;
            font-size: 41px;
        }
    }
    .avatar-item {
    
        .bg-avatar {
            position: absolute;
            overflow: hidden;
            margin: 0 auto;
            cursor: pointer;
            transform: scale(0.9) rotate(0deg);
            transition: transform .15s ease-in-out;
            opacity: 0.5;
    
            img {
                width: 100%;
                pointer-events: none;
            }
        }
        
        &:hover {
            .bg-avatar {
                position: absolute;
                overflow: hidden;
                margin: 0 auto;
                cursor: pointer;
                transform: scale(1) rotate(15deg);
                opacity: 0.8;
            }
        }
    }


    .avatar-player {
        position: relative;
        overflow: hidden;
        margin: 0 auto;
        cursor: pointer;

        img {
            width: 100%;
            pointer-events: none;
        }
    }

    .overflow-y-auto {
        overflow-y: auto !important;
    }

    .flex-1 {
        flex: 1 !important;
    }

    .app_title {
        position: relative;
        color: var(--app-color-text);
        text-transform: uppercase;
        font-family: "headline-gothic-atf-rough-n1", sans-serif;
        font-weight: 400;
        font-style: normal;
        font-size: 77px !important;
        z-index: 9;
    }
    

    .app_title_sub {
        color: var(--app-color-text);
        font-size: 23px;
        font-weight: 400;
        text-transform: uppercase;
    }

    .app_description {
        color: var(--app-color-text);
        font-size: 23px;
        font-weight: 400;
    }

    .item-summary {
        font-size: 21px;
        color: var(--app-color-text);
    }

    .card {
        background-color: var(--app-color-text);
    }

    h4 {
        font-size: 18px;
        color: var(--app-color-black);
    }

    .case-hide {
        background: var(--app-color-light);
    }

    .--btn-modal {
        border: none;
        background-color: unset;
        color: var(--app-color-red);
        text-decoration-line: underline;
        font-weight: bold;
        &:focus {
            outline: none;
        }
    }

    .text-end {
        text-align: end !important;
    }

    .iframe-modal {
        position: absolute;
        top: 4%;
        right: 7%;
        &:focus {
            outline: none;
        }
        .--btn-modal-iframe {
            color: #7A7A7A;
        }
    }

</style>
